<template>
  <div>
    <el-card>
      <div>
        <el-row>
          <el-col :lg="4" :md="4">
            <a @click="goBack"><i class="el-icon-back"/> Back </a> | <span style="color: #0a8700"><i class="fas fa-folder-open"/> {{ directory_title }}</span>
          </el-col>
          <el-col :lg="20" :md="14">
            <span style="float: right;"><a style="color: #0a8700" @click="newFile(true)"><i class="fas fa-file-alt"/> New File</a></span>
          </el-col>
        </el-row>

      </div>
    </el-card>
    <el-row>
      <el-col :lg="4" :md="4">
        <br>
        <span style="padding-left: 20px;">
          <el-input
            v-debounce="getAll"
            :debounce-events="'keydown'"
            v-model="search"
            placeholder="Type something">
            <i slot="prefix" class="el-input__icon el-icon-search"/>
          </el-input>
        </span>
      </el-col>
    </el-row>
    <el-row v-loading="loading" :gutter="10" style="min-height: 30vh" >
      <el-col v-for="file in data" :key="file.id" :xs="24" :sm="12" :md="3" :lg="3">
        <br>
        <a @click="previewfile(true, file, file.id)">
          <el-card shadow="hover" style="margin-right: 15px;margin-bottom: 15px; margin-left: 15px" >
            <div style="text-align: center">
              <br>
              <i class="far fa-file" style="font-size: 150px"/>
            </div>
            <div style="padding-top: 10px;">
              <el-row>
                <el-col :span="18">
                  <time>
                    {{ file.name }}
                  </time>
                </el-col>
              </el-row>
              <el-row>
                <time class="time" style="cursor: pointer;">
                  {{ file.desc }}
                </time>
              </el-row>
            </div>
          </el-card>
        </a>
      </el-col>
    </el-row>
    <div style="text-align: center; padding-bottom: 20px">
      <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
    </div>
    <el-dialog
      :visible.sync="addFile"
      title="New File"
      width="30%">
      <el-form>
        <el-form-item label="Name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="Description">
          <el-input
            v-model="form.desc"
            type="textarea"
            placeholder="Please input"
            maxlength="30"
            show-word-limit
          />
        </el-form-item>
        <el-form-item ref="attachment_path" label="Supporting Document" class="job-attach" prop="attachment_path" >
          <uploader-component :path.sync="form.file" :disabled="editable" class="my-upload-job" @setAttachment="form.file = $event" />
        </el-form-item>
        <el-button type="primary" @click="save()">Yes! submit</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
      v-if="previewFile"
      :visible.sync="previewFile"
      :title="file_object.name"
      width="50%"
      top
      custom-class="file-dialog">
      <show-file v-loading="loading" :file="file" :file_object="file_object" />
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--        <el-button @click="previewFile = false">Cancel</el-button>-->
      <!--        <el-button type="primary" @click="previewFile = false">Confirm</el-button>-->
      <!--      </span>-->
    </el-dialog>
  </div>

</template>

<script>
import { UploaderComponent } from '../../layout/components'
import { QMSFiles } from '@/api/qms'
import ShowFile from '../file-view'
import { Notification } from 'element-ui'
export default {
  name: 'Table',
  components: { UploaderComponent, ShowFile },
  props: {
    directory_id: {
      type: Number,
      require: true,
      default: 0
    },
    directory_title: {
      type: String,
      require: true,
      default: ''
    },
    directory: {
      type: Object,
      require: true,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      file: '',
      search: '',
      file_object: {},
      addFile: false,
      previewFile: false,
      editable: true,
      meta: {
        per_page: 12
      },
      data: [],
      form: {
        file: '',
        filename: '',
        file_type: 1,
        name: '',
        desc: '',
        directory_id: 0
      }
    }
  },
  created() {
    // this.getFile()
    this.loading = true
    this.getAll()
  },
  methods: {
    goBack() {
      // this.$parent.closeTable(false)
      this.$emit('close', false)
    },
    newFile(flag) {
      this.addFile = flag
    },
    formAddAttachment(file, fileList) {
      this.form.file = fileList
    },
    getAll() {
      QMSFiles({ per_page: this.meta.per_page, search: this.search, directory_id: this.directory_id }).then(res => {
        this.meta = res.data.meta
        this.data = res.data.file
        this.loading = false
      }).catch()
    },
    save() {
      // var form_data = new FormData()
      // form_data.append('file-view', this.form.file-view)
      this.form.directory_id = this.directory.id
      this.form.year = this.directory.year
      QMSFiles(this.form, 'post').then(res => {
        if (res.data.status === 'success') {
          Notification.success({
            title: 'Success',
            message: 'File is successfully save',
            duration: 4 * 1000
          })
          this.getAll()
          this.newFile(false)
        }
      }).catch()
    },
    previewfile(flag, file_object, id) {
      this.file = ''
      this.loading = true
      this.file_object = file_object
      this.previewFile = flag
      this.getFile(id)
    },
    getFile(id) {
      QMSFiles({ id: id }, 'get').then(res => {
        this.file = 'data:application/pdf;base64,' + res.data.message
        this.loading = false
      }).catch()
    }
  }
}
</script>

<style lang="scss">
  .el-dialog.file-dialog {
    text-align: center;
  }
  .file-iframe {
    width: 100%;
    pointer-events: all;
  }
</style>
